import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Trainings/Update';

const { displayName } = config;

function VideoUpdate(): React.JSX.Element {
  document.title = `${displayName}: Редактировать тренировку`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default VideoUpdate;
